import { render, staticRenderFns } from "./Flag.vue?vue&type=template&id=8897b47a&scoped=true&"
import script from "./Flag.vue?vue&type=script&lang=js&"
export * from "./Flag.vue?vue&type=script&lang=js&"
import style0 from "./Flag.vue?vue&type=style&index=0&id=8897b47a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8897b47a",
  null
  
)

export default component.exports